import React, { useContext, useEffect } from 'react';
import { Link, NavLink, Outlet, Navigate, useSearchParams, useNavigate, useLocation } from 'react-router-dom';
import { Sidebar, Menu, Segment, Header, Icon, Image, Dimmer, Loader } from 'semantic-ui-react';

import { LogoTextBlue, LogoBlue, multipleRestriction, RestrictView, SETTINGS_PERMISSION_MAP, productRestriction, PRODUCT_PERMISSIONS } from 'dyl-components'; 
import TopNavigation from './TopNavigation';
import userActions from "actions/user";

import './index.scss';
import { SETTINGS, SETTINGS_ROOT } from 'shared/constants/SETTINGS';
import { useSelector, useDispatch } from 'react-redux';
import RightSidebar from 'pages/Main/subcomponents/RightSidebar';
import Simulation from 'shared/Simulation';
import { MainSidePanelContext } from 'shared/context/MainSidePanelProvider';
import { Error403 } from 'pages/ErrorPages';
import { MessageBanner } from "dyl-components"
const SettingsPage = () => {
    const { isSidePanelOpen : isSidebarOpen , onOpenSidePanel , onCloseSidePanel } = useContext(MainSidePanelContext)

    const img = isSidebarOpen
        ? { src: LogoTextBlue}
        : { src: LogoBlue};
    
    const isAuthenticatingUser = useSelector(state => state.auth.isAuthenticatingUser);
    const authenticateUserMessage = useSelector(state => state.auth.authenticateUserMessage);
    const user_id = useSelector(state => state.auth.user_id);
    const hasOutstandingInvoices = useSelector(state => state.auth.company_status === 'paused');
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const locationPath = location.pathname;
    const isDyl = useSelector(state => state.auth.dyl_employee);
    const role = useSelector(state => state.auth.access_role);
    const { productPermissions, userPermissions } = useSelector(state => ({
        productPermissions: state.subscription.productPermissions,
        userPermissions: state.role.userPermissions.permission
    }));
    const dylNumbers = "numbers/dyl-numbers";

    useEffect(() => {
        dispatch(userActions.readLoggedInUserProfileLogo({ thumbnail: true, user_id }))
    }, [dispatch, user_id]);

    if (isAuthenticatingUser) {
        return (
            <Dimmer active>
                <Loader active />
            </Dimmer>
        )
    }
    
    if ((!isAuthenticatingUser && authenticateUserMessage !== 'success')) {
        return <Navigate to="/login" />;
    }

    const isRightSidebarOpen = params.get('module_id') !== null;

    const onCloseRightSidebar = () => {
        if (isRightSidebarOpen) {
            const query = new URLSearchParams(params);
            query.delete('module_id');
            query.delete('module_tab');
            const query_string = query.toString();
            navigate(`${locationPath}${query_string ? `?${query_string}` : ''}`, { state: { isTogglingPanel: true } });
        }
    }
    return (
        <div className="SettingsPage">
            <Simulation isSidebarOpen={isSidebarOpen} />
            <TopNavigation isSidebarOpen={isSidebarOpen} setSidebarOpen={() => { isSidebarOpen? onCloseSidePanel() : onOpenSidePanel() }} />
            <Sidebar.Pushable as={Menu} attached className='SettingsPage__SidebarPushable'>
                <Sidebar id="settingsSidebar" as={Menu} inverted visible={true} vertical borderless className={`SettingsPage__Sidebar SettingsPage__Sidebar${isSidebarOpen ? '--full' : '--squished'}`} >
                    <Menu.Item as={Link} to="/" className={`Sidebar__MenuItem`}>
                        <Image src={img.src} size={img.size} className='MenuItem__DYL2Logo' />
                    </Menu.Item>
                  {/* //TODO: This Static Permissions need to be removed   */}
                    {SETTINGS.map(({ path, name, icon, description, child }) => {
                        child = (child === dylNumbers) && !productRestriction(PRODUCT_PERMISSIONS.OFFICE_VIEW, productPermissions) ? 'numbers/external-numbers' : child
                        const viewPaths = SETTINGS_PERMISSION_MAP?.[path];
                        const isRestricted = path?.includes("dyl-admin")
                            ? !(isDyl && ["Administrator", "Administrative Owner"].includes(role))
                            : multipleRestriction(viewPaths, userPermissions);
                        return (
                        <RestrictView type="hidden" error403={<Error403 />} isRestricted={isRestricted}>
                            <Menu.Item
                                active={false}
                                as={NavLink}
                                to={`/${SETTINGS_ROOT}${path ? `/${path}` : '/'}${child ? `/${child}` : ''}`}
                                className={`Sidebar__MenuItem Sidebar__MenuItem${isSidebarOpen ? '--full' : '--squished'}`}
                            >
                                {isSidebarOpen ?
                                    <div className='MenuItem__Container'>
                                        <div className='MenuItem__Icon'>
                                            <Icon className={icon} />
                                        </div>
                                        <div className='MenuItem__Name'>
                                            <Header as='h4'>
                                                {name}
                                                <Header.Subheader>
                                                    {description}
                                                </Header.Subheader>
                                            </Header>
                                        </div>
                                    </div>
                                    : <Icon className={icon} />}
                            </Menu.Item>
                        </RestrictView>
                )})}
                </Sidebar>
                <RightSidebar
                    onClose={onCloseRightSidebar}
                    open={isRightSidebarOpen}
                />
                <Sidebar.Pusher className={`SettingsPage__SidebarPusher SettingsPage__SidebarPusher${isSidebarOpen ? '--full' : '--squished'}`} style={{ overflow: 'visible' }}>
                    <Segment basic className={`SidebarPusher__Segment SidebarPusher__Segment${isSidebarOpen ? '--full' : '--squished'}`}>
                        {hasOutstandingInvoices && (
                             <MessageBanner text={"Outstanding invoices: Please click on Fund Account to proceed"} style={{ top: '4.8rem' }}/>
                        )}
                        <div className={`SettingsPage__content SettingsPage__content${hasOutstandingInvoices ? '--padded' : ''}`}>
                            <Outlet />
                        </div>
                    </Segment>
                </Sidebar.Pusher>
            </Sidebar.Pushable>
        </div>
    )
};

export default SettingsPage;
